import React from "react";
import { ReactController } from "../react_controller";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import { ReadOnlyPrimerGrid } from "../../components/grids";

const queryClient = new QueryClient();

export class ReadOnlyPrimerGridController extends ReactController {
  connect() {
    this.root.render(
      <QueryClientProvider client={queryClient}>
        <ReadOnlyPrimerGrid {...this.propsValue} />
      </QueryClientProvider>
    );
  }
}
